module.exports = "<div class=\"gw-schedule-prop-header\" ng-class=\"{'gw-schedule-prop-header_right-aligned': rightAligned}\">\r\n    {{property().getLabel()}}<span ng-if=\"!hideRequired && property().isRequired()\">*</span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/propertyHeaders/table/templates/Default.html
// module id = 450
// module chunks = 0